import {FileService} from '../services/file.service';

export default function (metadata) {
  if(FileService.hasVideoAnalytics(metadata)){
    return FileService.formatDuration(metadata.video_duration)
  }
  return FileService.formatSize(metadata.content_length);
};
